import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import CodeField from "../Reusable/CodeField";
import Modal from "../Reusable/Modal";
import TextField from "../Reusable/TextInput";
import { Group, Panel, Separator } from "react-resizable-panels";
import DOMPurify from "dompurify";
import TabPanel from "../Reusable/Tab";

const EditTemplate = (props: any) => {
  const {
    templateData,
    handleEdit,
    isPatchLoading,
    handleReset,
    isopenWarningPopup,
    setIsOpenWarningPopup,
  } = props;

  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    control,
    watch,
  } = useForm({
    defaultValues: async () => {
      return {
        name: templateData?.name,
        description: templateData?.description,
        html: templateData?.html,
      };
    },
  });
  const Html = watch("html");
  const sanitizeTemplateForPreview = (html: string) => {
    return html;
    // .replace(/\{%\s*load[\s\S]*?%\}/g, "")
    // .replace(/\{%\s*(for|if|with)[\s\S]*?%\}/g, "<!-- django:start -->")
    // .replace(/\{%\s*(endfor|endif|endwith)\s*%\}/g, "<!-- django:end -->")
    // .replace(/\{%\s*else\s*%\}/g, "<!-- django:else -->")
    // .replace(/\{\{[\s\S]*?\}\}/g, "____")
  };
  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data: any) => handleEdit(data, setError))}
          autoComplete={"off"}
        >
          <TabPanel
            tabTitle={["Default Template", "Custom Template"]}
            tabPanels={[
              <>
                <div className={tw`flex gap-x-4 `}>
                  <TextField
                    register={register("name")}
                    label={"Name"}
                    errors={errors?.name}
                  />
                  <TextField
                    register={register("description")}
                    label={"Description"}
                    errors={errors?.description}
                  />
                </div>
                <div>
                  <div className={tw`flex justify-between items-center`}>
                    <label htmlFor="">HTML Code</label>
                    <p
                      className={tw`cursor-pointer`}
                      onClick={() => setIsOpenWarningPopup(!isopenWarningPopup)}
                    >
                      Reset
                    </p>
                  </div>
                  <Group orientation="horizontal" className={tw`h-[450px]`}>
                    <Panel defaultSize={50} minSize={30}>
                      <CodeField control={control} name="html" />
                    </Panel>
                    <Separator
                      className={tw`w-[2px] bg-gray-200 cursor-col-resize hover:bg-gray-300 transition `}
                    />
                    <Panel defaultSize={50} minSize={30}>
                      <div
                        className={tw`h-full p-4 border bg-white overflow-auto`}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              sanitizeTemplateForPreview(Html || "")
                            ),
                          }}
                        />
                      </div>
                    </Panel>
                  </Group>
                </div>

                <div className={tw`flex justify-end`}>
                  <div className={tw`w-32`}>
                    <Button label={"Update"} isLoading={isPatchLoading} />
                  </div>
                </div>
              </>,
              <>
                <div className={tw`flex gap-x-4 `}>
                  <TextField
                    register={register("name")}
                    label={"Name"}
                    errors={errors?.name}
                  />
                  <TextField
                    register={register("description")}
                    label={"Description"}
                    errors={errors?.description}
                  />
                </div>
                <div>
                  <div className={tw`flex justify-between items-center`}>
                    <label htmlFor="">HTML Code</label>
                    <p
                      className={tw`cursor-pointer`}
                      onClick={() => setIsOpenWarningPopup(!isopenWarningPopup)}
                    >
                      Reset
                    </p>
                  </div>
                  <Group orientation="horizontal" className={tw`h-[450px]`}>
                    <Panel defaultSize={50} minSize={30}>
                      <CodeField control={control} name="html" />
                    </Panel>
                    <Separator
                      className={tw`w-[2px] bg-gray-200 cursor-col-resize hover:bg-gray-300 transition `}
                    />
                    <Panel defaultSize={50} minSize={30}>
                      <div
                        className={tw`h-full p-4 border bg-white overflow-auto`}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              sanitizeTemplateForPreview(Html || "")
                            ),
                          }}
                        />
                      </div>
                    </Panel>
                  </Group>
                </div>

                <div className={tw`flex justify-end`}>
                  <div className={tw`w-32`}>
                    <Button label={"Update"} isLoading={isPatchLoading} />
                  </div>
                </div>
              </>,
            ]}
          />
        </form>
      </Card>
      <Modal isOpen={isopenWarningPopup} setIsOpen={setIsOpenWarningPopup}>
        <div className="flex flex-col items-center">
          <p className="font-semibold">
            Are you sure do you want to change to default
          </p>
          <div className={tw`flex gap-x-4 px-10 items-center mt-4`}>
            <div className={tw`w-24`}>
              <Button
                type={"button "}
                label={"Yes"}
                onClick={() => handleReset()}
              />
            </div>
            <div className={tw`w-24`}>
              <Button
                type={"button "}
                label={"Cancel"}
                onClick={() => setIsOpenWarningPopup(!isopenWarningPopup)}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditTemplate;
